import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error('Root element not found');
  document.body.innerHTML = '<h1 style="color: red;">Error: Root element not found</h1>';
}

// Add global error handler to catch any React errors
window.addEventListener('error', (e) => {
  console.error('Global error:', e.error);
  document.body.innerHTML = `<h1 style="color: red;">Error: ${e.error?.message || e.message}</h1><pre>${e.error?.stack || ''}</pre>`;
});
